import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaGarantiasLaboralesByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaGarantiasLaboralesByUser = () => {
  const [loadingGetDeclaracionJuradaGarantiasLaboralesByUser, setLoadingGetDeclaracionJuradaGarantiasLaboralesByUser] = useState(false);
  const [successGetDeclaracionJuradaGarantiasLaboralesByUser, setSuccessGetDeclaracionJuradaGarantiasLaboralesByUser] = useState(false);
  const [errorGetDeclaracionJuradaGarantiasLaboralesByUser, setErrorGetDeclaracionJuradaGarantiasLaboralesByUser] = useState<any>(null);
  const [dataGetDeclaracionJuradaGarantiasLaboralesByUser, setDataDeclaracionJuradaGarantiasLaboralesByUser] = useState<any>(null);

  const [statusGetDeclaracionJuradaGarantiasLaboralesByUser, setStatusGetDeclaracionJuradaGarantiasLaboralesByUser] =
    useState<StatusGetDeclaracionJuradaGarantiasLaboralesByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaGarantiasLaboralesByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionJuradaGarantiasLaboralesByUser(true);
    setSuccessGetDeclaracionJuradaGarantiasLaboralesByUser(false);
    setErrorGetDeclaracionJuradaGarantiasLaboralesByUser(null);

    try {
      const res = await apirecord.getSolicitudDeclaracionJuradaGarantiasByUser(userId, expedienteId);

      setStatusGetDeclaracionJuradaGarantiasLaboralesByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetDeclaracionJuradaGarantiasLaboralesByUser(true);
      setDataDeclaracionJuradaGarantiasLaboralesByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaGarantiasLaboralesByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaGarantiasLaboralesByUser(err);
      console.error("Error en getDeclaracionJuradaGarantiasLaboralesByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionJuradaGarantiasLaboralesByUser(false);
    }
  };

  return {
    getDeclaracionJuradaGarantiasLaboralesByUser,
    loadingGetDeclaracionJuradaGarantiasLaboralesByUser,
    successGetDeclaracionJuradaGarantiasLaboralesByUser,
    errorGetDeclaracionJuradaGarantiasLaboralesByUser,
    dataGetDeclaracionJuradaGarantiasLaboralesByUser,
    statusGetDeclaracionJuradaGarantiasLaboralesByUser
  };
};

export default useGetDeclaracionJuradaGarantiasLaboralesByUser;
